module.exports = __webpack_public_path__ + "img/2.8442b99b.jpg";